import { getSegmentRuleDisplayValue } from '@salecycle/experimental/Segmentation/getSegmentRuleDisplayValue';
import { TFunction } from 'i18next';

type SegmentationRuleLike = { type: string; configuration?: { condition?: string; value?: string }; or?: boolean };

export const formatSegmentationForTooltip = (rules: SegmentationRuleLike[][] | undefined, t: TFunction): string => {
  if (!rules?.length) return '';

  const parts: string[] = [];

  rules.forEach((group, groupIndex) => {
    if (groupIndex > 0) {
      parts.push(`\n${t('onsite.segmentationRules.logic.and')} `);
    }

    group.forEach((rule, ruleIndex) => {
      if (ruleIndex > 0) {
        parts.push(`\n${t('onsite.segmentationRules.logic.or')} `);
      }

      const typeLabel = t(`onsite.segmentationRules.types.${rule.type}`);
      const conditionLabel = rule.configuration?.condition
        ? t(`onsite.segmentationRules.conditions.${rule.configuration.condition}`)
        : '';
      const valueLabel = getSegmentRuleDisplayValue(rule, t);

      const line = [typeLabel, conditionLabel, valueLabel].filter(Boolean).join(' ');
      parts.push(line);
    });
  });

  return parts.join('');
};
